<div class="mainTitle">Fitness Plans</div>

<!-- Tab Navigation -->
<div class="tab-navigation">
  <div class="tab-buttons">
    <button
      class="tab-btn"
      [class.active]="activeTab === 'all'"
      (click)="setActiveTab('all')"
    >
      All Members
    </button>
    <button
      class="tab-btn"
      [class.active]="activeTab === 'unassigned'"
      (click)="setActiveTab('unassigned')"
    >
      Unassigned Members
    </button>
  </div>
  <div class="actions-container">
    <button class="manage-templates-btn" (click)="navigateToTemplates()">
      <span class="template-icon">📋</span>
      Manage Templates
    </button>
    <div class="search-container">
      <input
        matInput
        type="textbox"
        placeholder="Search by member"
        class="search-input"
        [(ngModel)]="name"
        (keyup)="searchByMember($event)"
      />
      <button class="search-btn">
        <span class="search-icon">🔍</span>
      </button>
    </div>
  </div>
</div>

<!-- Members Grid -->
<div class="members-container">
  <ng-container *ngFor="let rec of memberList">
    <div class="members-row">
      <div class="member-col" *ngFor="let r of rec">
        <app-basic-info [member]="r"></app-basic-info>
      </div>
    </div>
  </ng-container>
</div>
<div class="row mt-3 justify-content-center">
  <mat-paginator
    #paginator
    (page)="pageChangeEvent($event)"
    [pageSize]="10"
    [pageIndex]="0"
    [length]="this.resp?.members?.metadata?.totalCount"
    showFirstLastButton
  >
  </mat-paginator>
</div>
